import React             from 'react';
import FieldValidation   from '../Fragments/FieldValidation';
import FieldError       from '../Fragments/FieldError';
import HelpIcon          from '../Fields/HelpIcon';
import HelpText          from '../Fields/HelpText';
import ChildQuestion     from './ChildQuestion';
import Modal             from '../Fragments/Modal';
import ClaimsModal       from '../Modals/ClaimsModal';
import DeleteClaimsModal from '../Modals/DeleteClaimsModal';

let Claim       = require('../Managers/Claim');
let Quote       = require('../Managers/Quote');
let Questions   = require('../Managers/Questions');

const PreviousClaimChoice = React.createClass({

    propTypes: {
        questionId: React.PropTypes.number.isRequired,
        question: React.PropTypes.string.isRequired,
        fieldName: React.PropTypes.string.isRequired,
        options: React.PropTypes.array.isRequired,
        loadCachedValue: React.PropTypes.bool.isRequired,
        helpText: React.PropTypes.string,
        children: React.PropTypes.array,
        supplementaryText: React.PropTypes.string,
        supplementaryTextAfterInput: React.PropTypes.string,
        onSetValue: React.PropTypes.func,
        refName: React.PropTypes.string,
        alternateBackground: React.PropTypes.string,
        noBorder: React.PropTypes.string,
    },

    getInitialState() {
        // work out if we have any claims
        let claims = JSON.parse(window.localStorage.getItem('previous_claims'));
        if (claims == undefined) {
            claims = undefined;
        }

        return {
            activeValue: (this.props.loadCachedValue) ? Quote.getCurrentAnswer(this.props.fieldName) : null,
            otherActiveValue: null,
            childObjects: Questions.getChildren(this.props.children),
            hasError: false,
            isValid: (this.props.loadCachedValue) ? Quote.getCurrentAnswer(this.props.fieldName) : null,
            isHelpVisible: false,
            showChildren: Questions.childrenAreActive(this.props.children, this.props.fieldName),
            childrenToUse: Questions.getChildQuestions(this.props.questionId, Quote.getCurrentAnswer(this.props.fieldName)),
            supplementaryTextModalActive: false,
            supplementaryTextModal: {
                title: null,
                template: null
            },
            showOtherActiveValues: false,
            hasOtherOptions: Questions.hasOtherAnswerOptions(this.props.fieldName),
            previous_claims : claims
        };
    },
    showClaimsModal : function(claim) {
        if (claim.guid == undefined) {
            claim = undefined;
        }
        this.refs.ClaimsModal.showClaimsModal(claim);
    },
    doValidation() {
        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        this.setState({
            hasError : false,
            errors : []
        });
        return true;
    },
    deleteClaimsModal : function(claim) {
        this.refs.DeleteClaimsModal.showClaimsModal(claim);
    },
    setActiveValue(key, value) {
        // Toggle the other button options off and remove their values from the state
        if (this.state.showOtherActiveValues) {
            this.setState({
                showOtherActiveValues: false
            });
        }

        // we need an answer to the dec question itself
        Quote.set(key, value);
        this.setState({
            activeValue: value,
            isValid: true,
            childrenToUse: Questions.getChildQuestions(this.props.questionId, value)
        });

        // if we just hit yes, show the modal
        if (value == 'yes') {
            this.refs.ClaimsModal.showClaimsModal();
        }

        if (value == 'no') {
            // we need to delete all the claims if they say no
            this.setState({
                previous_claims : {}
            });
            Claim.deleteAll();
        }

        if (this.props.onSetValue) {
            this.props.onSetValue(value);
        }
    },

    setOtherActiveValue(e) {
        Quote.set(this.props.fieldName, e.target.value);
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },

    closeSupplementaryTextModal: function() {
        this.setState({
            activeValue: Quote.getCurrentAnswer(this.props.fieldName),
            supplementaryTextModalActive: false
        });
    },

    showOtherOptions() {
        this.setState({
            activeValue: null,
            showOtherActiveValues: true
        });
    },

    addClaim : function(claim) {
        Claim.add(claim.type, claim.value, claim.month, claim.year);
        this.setState({
            previous_claims : Claim.get()
        });
    },

    editClaim : function(claim) {
        Claim.edit(claim.guid, claim.type, claim.value, claim.month, claim.year);
        this.setState({
            previous_claims : Claim.get()
        });
    },

    deleteClaim : function(guid) {
        Claim.delete(guid);
        this.setState({
            previous_claims : Claim.get()
        });
    },

    resetClaimsQuestion : function() {
        this.setActiveValue(this.props.fieldName, 'no');
    },

    render() {
        let activeVal = (this.state.showOtherActiveValues) ? null : Quote.getCurrentAnswer(this.props.fieldName);
        let topClass = (this.props.helpText) ? 'question-top with-help' : 'question-top without-help';

        let otherOptions = [];
        if (this.state.showOtherActiveValues) {
            Questions.getOtherAnswerOptions(this.props.fieldName).map(function(i, index) {
                otherOptions.push(<option key={index+'_'+Questions.guid()} value={i.option_value}>{i.option_text}</option>);
            }, this);
        }

        let containerClass = '';
        if (this.props.alternateBackground) {
            containerClass = 'alternate-background';
        }

        let questionRowClass = '';
        if (this.props.noBorder) {
            questionRowClass = 'no-border';
        }

        // stuff for table
        let claimData = this.state.previous_claims;
        let claimRows = [];
        window.$.each(claimData, (i, e) => {
            let month = (0 + e.month).slice(-2);
            e.guid = i;
            claimRows.push(
                <tr key={i}>
                    <td data-label="Type">{Claim.getTypeStringForId(e.type)}</td>
                    <td data-label="Date">{month}/{e.year}</td>
                    <td data-label="Value">£{e.value}</td>
                    <td className="controls left"><span className="pointer" onClick={() => this.showClaimsModal(e)}>Edit</span></td>
                    <td className="controls right"><span className="pointer" onClick={() => this.deleteClaimsModal(e)}>Delete</span></td>
                </tr>
            );
        });

        return (
            <div ref={this.props.fieldName+'_'+Questions.guid()} className={containerClass}>
                <question-row class={questionRowClass}>
                    <div className="question-main">

                        <div className={topClass}>
                            <label>{this.props.question}</label>
                            {this.props.helpText ? <HelpIcon onClick={this.toggleHelpText} />: null}
                        </div>

                        <div className="question-input">
                            <div className="button-choices two">
                                {this.props.options.map(function(choice, index) {
                                    let choiceId = (choice.id != undefined) ? choice.id : Math.random();
                                    return (
                                        <div
                                            key={index}
                                            onClick={this.setActiveValue.bind(this, this.props.fieldName, choice.option_value)}
                                            value={choice.value}
                                            id={choiceId}
                                            className={activeVal == choice.option_value ? 'button-choice active' : 'button-choice'}>
                                            {choice.option_text}
                                        </div>
                                    );
                                }, this)}
                                {this.state.hasOtherOptions ?
                                    <div
                                        onClick={this.showOtherOptions}
                                        className={this.state.showOtherActiveValues ? 'button-choice active' : 'button-choice'}>
                                        Other
                                    </div>
                                : null}
                                {this.state.showOtherActiveValues ? <select onChange={this.setOtherActiveValue} className="otherOptionsSelect"><option>Please select ...</option>{otherOptions}</select> : null}
                            </div>
                            {this.props.helpText ? <HelpText text={this.props.helpText} active={this.state.isHelpVisible} /> : null}
                            {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                        </div>
                    </div>
                    <div className="question-extra">
                        <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                    </div>
                </question-row>

                <child-questions>
                {this.state.childrenToUse !== null ?
                    this.state.childrenToUse.map(function(child, index) {
                        return (
                            <ChildQuestion
                                show={this.state.showChildren}
                                key={index+'_'+Questions.guid()}
                                question={child.question}
                                questionId={child.question_id}
                                fieldName={child.field_name}
                                type={child.type}
                                options={child.options}
                                display_dependencies={child.display_dependencies}
                                parent={child.parent}
                                helpText={child.hint_text}
                             />
                        );
                    }, this)

                : null}
                </child-questions>
                {this.state.supplementaryTextModalActive ?
                <Modal
                    closeFunction={this.closeSupplementaryTextModal}
                    title={this.state.supplementaryTextModal.title}
                    bodyTemplate={this.state.supplementaryTextModal.template}
                    isActive={true}
                    setActiveValue={this.setActiveValue}
                /> : null }

                <ClaimsModal
                    resetClaimsQuestion={this.resetClaimsQuestion}
                    addClaim={this.addClaim}
                    editClaim={this.editClaim}
                    ref="ClaimsModal"
                />
                <DeleteClaimsModal
                    resetClaimsQuestion={this.resetClaimsQuestion}
                    deleteClaim={this.deleteClaim}
                    ref="DeleteClaimsModal"
                />

                {! window.isEmpty(this.state.previous_claims) ?
                    <div className="full-width-table-container">
                        <h3 className="hidden-md-up">Claims</h3>
                        <table className="data-rows table mobile-table">
                            <thead>
                            <tr>
                                <th>Claim type</th>
                                <th>Date</th>
                                <th>Value</th>
                                <th colSpan="3" />
                            </tr>
                            </thead>
                            <tbody id="claim-rows">
                                {claimRows}
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan="5">
                                    <a onClick={this.showClaimsModal}>Add another claim</a>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                : null}
            </div>
        );
    }
});

export default PreviousClaimChoice;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/PreviousClaimChoice.js
 **/